import React, { useState, useEffect } from 'react';
import { Link } from "gatsby"
import './assets/styles/_index.scss';
import { NoResultProperties } from '../../queries/common_use_query';
import { ShowProcessedImage } from "../common/ggfx-client/module/components/show-image"
import imageConfig from "../../../static/images/config.json"
import NoImg from "../../images/no-image.png"

const PropertyNoResult = (props) => {

    const[department, setDepartment] = useState('residential');

    useEffect(()=>{
        props.department && setDepartment(props.department);
    },[props.department]);

    const {loading:loading, error:error, data:noResultdata} = NoResultProperties(props.status, department, props.searchType);

    return (
        <React.Fragment>
            {
                noResultdata && noResultdata.properties.length > 0 &&
                noResultdata.properties.map((hit, index) => {

                    // property details url structure
                    let uriStr = "";
                    
                    if (hit.search_type === "sales" && hit.department === 'residential') {
                        uriStr = `property-for-sale/`
                    } else if (hit.search_type === "lettings" && hit.department === 'residential') {
                        uriStr = `property-for-rent/`
                    }else if(hit.search_type === "sales" && hit.department === "commercial"){
                        uriStr = `commercial-property-for-sale/` 
                      } else if(hit.search_type === "lettings" && hit.department === "commercial"){
                        uriStr = `commercial-property-for-rent/`  
                      }
                    // property details url structure

                    let processedImages = JSON.stringify({});
                    if (hit?.imagetransforms?.images_Transforms) {
                      processedImages = hit.imagetransforms.images_Transforms;
                    }

                    return (
                        <div className="property-card-wrapper">
                            <div className="property-card-img-zoom">
                                {
                                    hit?.images && hit?.images.length > 0 ?
                                    <Link to={`/${uriStr}${hit.slug}-${hit.id}/`}>
                                        <img src={hit?.images && hit?.images[0].url} alt={hit.display_address} />
                                        {/* <ShowProcessedImage
                                            images={hit?.images && hit?.images[0]}
                                            attr={{
                                                className: "img-fluid",
                                                alt: hit.display_address + " - White & Co Real Estate Real Estate",
                                            }}
                                            transforms={imageConfig.property.searchResults.sizes}
                                        /> */}
                                    </Link>
                                    :
                                    <Link to={`/${uriStr}${hit.slug}-${hit.id}/`}>
                                        <img src={NoImg} alt="no image" />
                                    </Link>
                                }
                            </div>
                            <div className="property-card-text-wrapper">
                                {
                                    hit.price &&
                                    <div className="price-details">{hit.price.toLocaleString()} {hit.currency}</div>
                                }
                                {
                                    hit.display_address &&
                                    <p className="display-address">{hit.display_address}</p>
                                }
                                {
                                    hit.area &&
                                    // <div className="location-details d-flex align-items-center">
                                    <div className="location-details d-flex">
                                        <i className="icon icon-map-pin"></i>
                                        <span>{hit.area}</span>
                                    </div>
                                }
                            </div>
                        </div>
                    )
                })
            }
        </React.Fragment>
    )
}

export default PropertyNoResult